class LpHeaderCountdown {
    constructor(el) {
        this.el = el;
        this.endTime = parseInt(el.dataset.countdownEndTime);
        this.daysWrap = el.querySelector('.lp-announcement-bar__countdown-days');
        this.daysSpan = this.daysWrap.querySelector('span');
        const directSpans = [...el.children].filter(c => c.tagName === 'SPAN' && !c.classList.contains('lp-announcement-bar__countdown-days'));
        this.hoursSpan = directSpans[0];
        this.minutesSpan = directSpans[1];
        this.secondsSpan = directSpans[2];
        this.update();
        this.interval = setInterval(() => this.update(), 1000);
    }

    update() {
        const now = Math.floor(Date.now() / 1000);
        const timeLeft = this.endTime - now;

        if (timeLeft <= 0) {
            clearInterval(this.interval);
            this.daysWrap.style.display = 'none';
            this.hoursSpan.textContent = '00';
            this.minutesSpan.textContent = '00';
            this.secondsSpan.textContent = '00';
            return;
        }

        const days = Math.floor(timeLeft / 86400);
        const hours = Math.floor((timeLeft % 86400) / 3600);
        const minutes = Math.floor((timeLeft % 3600) / 60);
        const seconds = timeLeft % 60;

        if (days === 0) {
            this.daysWrap.style.display = 'none';
        } else {
            this.daysWrap.style.display = '';
            this.daysSpan.textContent = String(days).padStart(2, '0');
        }

        this.hoursSpan.textContent = String(hours).padStart(2, '0');
        this.minutesSpan.textContent = String(minutes).padStart(2, '0');
        this.secondsSpan.textContent = String(seconds).padStart(2, '0');
    }
}

class LpAnnouncementBarScroll {
    constructor(el) {
        this.el = el;
        this.hideOnScrollMobile = el.dataset.hideOnScrollMobile === 'true';
        this.hideOnScrollDesktop = el.dataset.hideOnScrollDesktop === 'true';
        this.lastScrollY = window.scrollY || 0;
        this.ticking = false;
        this.isHidden = false;
        this.downDistance = 0;
        this.upDistance = 0;
        this.hideThreshold = 40;
        this.showThreshold = 32;
        this.topThreshold = 20;
        this.stateLockMs = 220;
        this.stateLockUntil = 0;

        if (!this.hideOnScrollMobile && !this.hideOnScrollDesktop) {
            return;
        }

        this.onScroll = this.onScroll.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        this.el.classList.add('lp-announcement-bar--can-hide');
        this.updateMeasuredHeight();
        this.updateVisibility(this.lastScrollY);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
    }

    onResize() {
        this.updateMeasuredHeight();
        this.emitStateChange();
    }

    updateMeasuredHeight() {
        const measuredHeight = Math.ceil(this.el.scrollHeight);
        this.el.style.setProperty('--lp-announcement-bar-height', `${measuredHeight}px`);
    }

    shouldHideForViewport() {
        const isDesktop = window.matchMedia('(min-width: 768px)').matches;
        if (isDesktop) {
            return this.hideOnScrollDesktop;
        }
        return this.hideOnScrollMobile;
    }

    onScroll() {
        if (this.ticking) {
            return;
        }

        this.ticking = true;
        window.requestAnimationFrame(this.handleScroll);
    }

    handleScroll() {
        const currentScrollY = window.scrollY || 0;
        this.updateVisibility(currentScrollY);
        this.lastScrollY = currentScrollY;
        this.ticking = false;
    }

    emitStateChange() {
        window.dispatchEvent(new CustomEvent('lp:announcement-bar:state-change', {
            detail: {
                hidden: this.isHidden,
                transitionMs: this.stateLockMs
            }
        }));
    }

    updateVisibility(currentScrollY) {
        if (!this.shouldHideForViewport()) {
            this.downDistance = 0;
            this.upDistance = 0;
            const wasHidden = this.isHidden;
            this.isHidden = false;
            this.el.classList.remove('is-hidden-on-scroll');
            if (wasHidden) {
                this.emitStateChange();
            }
            return;
        }

        if (Date.now() < this.stateLockUntil) {
            return;
        }

        const delta = currentScrollY - this.lastScrollY;

        if (Math.abs(delta) < 2) {
            return;
        }

        if (delta > 0) {
            this.downDistance += delta;
            this.upDistance = 0;
        } else {
            this.upDistance += Math.abs(delta);
            this.downDistance = 0;
        }

        if (!this.isHidden) {
            const shouldHide = delta > 0 && currentScrollY > this.topThreshold && this.downDistance >= this.hideThreshold;
            if (shouldHide) {
                this.isHidden = true;
                this.downDistance = 0;
                this.el.classList.add('is-hidden-on-scroll');
                this.stateLockUntil = Date.now() + this.stateLockMs;
                this.emitStateChange();
            }
            return;
        }

        const shouldShow = currentScrollY <= this.topThreshold || (delta < 0 && this.upDistance >= this.showThreshold);
        if (shouldShow) {
            this.isHidden = false;
            this.upDistance = 0;
            this.el.classList.remove('is-hidden-on-scroll');
            this.stateLockUntil = Date.now() + this.stateLockMs;
            this.emitStateChange();
        }
    }
}

class LpBoxCountdown {
    constructor(el) {
        this.el = el;
        this.endTime = parseInt(el.dataset.countdownEndTime);
        this.daysEl    = el.querySelector('[data-days]');
        this.hoursEl   = el.querySelector('[data-hours]');
        this.minutesEl = el.querySelector('[data-minutes]');
        this.secondsEl = el.querySelector('[data-seconds]');
        this.update();
        this.interval = setInterval(() => this.update(), 1000);
    }

    pad(n) { return String(n).padStart(2, '0'); }

    update() {
        const timeLeft = Math.max(0, this.endTime - Math.floor(Date.now() / 1000));

        if (timeLeft === 0) {
            clearInterval(this.interval);
        }

        const days    = Math.floor(timeLeft / 86400);
        const hours   = Math.floor((timeLeft % 86400) / 3600);
        const minutes = Math.floor((timeLeft % 3600) / 60);
        const seconds = timeLeft % 60;

        if (this.daysEl)    this.daysEl.textContent    = this.pad(days);
        if (this.hoursEl)   this.hoursEl.textContent   = this.pad(hours);
        if (this.minutesEl) this.minutesEl.textContent = this.pad(minutes);
        if (this.secondsEl) this.secondsEl.textContent = this.pad(seconds);
    }
}

class LpHeaderCollapseOnScroll {
    constructor(headerEl) {
        this.header = headerEl;
        this.section = headerEl.closest('.section-lp-header-section');
        if (!this.section) return;

        this.collapsed = false;
        this.headerHeight = 0;
        this.ticking = false;
        this.settling = false;
        this.settleTimer = null;

        this.measure();
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.update(window.scrollY || 0);
    }

    measure() {
        // Ceil so the collapse margin fully pulls the header up under the bar.
        // offsetHeight truncates sub-pixel heights, which can leave a thin sliver
        // of the header peeking below the bar and create a gap under the section.
        this.headerHeight = Math.ceil(this.header.getBoundingClientRect().height);
    }

    onResize() {
        this.measure();
        this.update(window.scrollY || 0, true);
    }

    onScroll() {
        // Ignore scroll events triggered by our own layout change.
        if (this.settling) return;
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
            this.update(window.scrollY || 0);
            this.ticking = false;
        });
    }

    update(scrollY, force = false) {
        const shouldCollapse = this.collapsed ? scrollY > 0 : scrollY >= 100;

        if (shouldCollapse === this.collapsed && !force) return;
        this.collapsed = shouldCollapse;
        this.header.style.marginTop = shouldCollapse ? `-${this.headerHeight}px` : '';
    }
}

class LpHeaderAnchorScroll {
    constructor(link) {
        this.link = link;
        this.onClick = this.onClick.bind(this);
        this.link.addEventListener('click', this.onClick);
    }

    onClick(e) {
        const href = this.link.getAttribute('href');
        const hashIndex = href ? href.indexOf('#') : -1;
        if (hashIndex === -1) return;

        const targetId = href.substring(hashIndex + 1);
        if (!targetId) return;

        const target = document.getElementById(targetId);
        if (!target) return;

        e.preventDefault();
        this.scrollToAnchor(target);
    }

    scrollToAnchor(target) {
        let offset = 0;

        const stickyElements = [
            document.querySelector('[data-header-section]'),
            document.querySelector('.section-lp-header-section'),
            document.getElementById('SectionAnnouncementBar'),
            document.querySelector('.page-anchor-navigation.is-active'),
            document.querySelector('.page-anchor-navigation.is-pinned'),
        ];

        stickyElements.forEach(el => {
            if (el) offset += Math.ceil(el.getBoundingClientRect().height);
        });

        const targetPosition = Math.max(
            0,
            target.getBoundingClientRect().top + window.pageYOffset - offset - 24
        );

        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    }
}

function initLpHeaderCountdowns(scope = document) {
    scope.querySelectorAll('[data-lp-countdown]').forEach(el => {
        if (el._lpCountdownInit) return;
        el._lpCountdownInit = true;
        new LpHeaderCountdown(el);
    });
    scope.querySelectorAll('[data-lp-countdown-box]').forEach(el => {
        if (el._lpBoxCountdownInit) return;
        el._lpBoxCountdownInit = true;
        new LpBoxCountdown(el);
    });
}

function initLpAnnouncementBarScroll(scope = document) {
    scope.querySelectorAll('[data-lp-announcement-bar]').forEach(el => {
        if (el._lpAnnouncementBarScrollInit) return;
        el._lpAnnouncementBarScrollInit = true;
        new LpAnnouncementBarScroll(el);
    });
}

function initLpHeaderCollapseOnScroll(scope = document) {
    scope.querySelectorAll('[data-collapse-on-scroll="true"]').forEach(el => {
        if (el._lpHeaderCollapseInit) return;
        el._lpHeaderCollapseInit = true;
        new LpHeaderCollapseOnScroll(el);
    });
}

function initLpHeaderAnchorScroll(scope = document) {
    scope.querySelectorAll('.lp-header__cta-button[href*="#"]').forEach(link => {
        if (link._lpAnchorScrollInit) return;
        link._lpAnchorScrollInit = true;
        new LpHeaderAnchorScroll(link);
    });
}

initLpHeaderCountdowns();
initLpAnnouncementBarScroll();
initLpHeaderCollapseOnScroll();
initLpHeaderAnchorScroll();

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
        initLpHeaderCountdowns(e.target);
        initLpAnnouncementBarScroll(e.target);
        initLpHeaderCollapseOnScroll(e.target);
        initLpHeaderAnchorScroll(e.target);
    });
}
